import { sessionPrefix } from "./helpers";

export const invoicesPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/invoices`;
export const showInvoicePath = (session: LightSessionInterface, invoice: InvoiceInterface) =>
  `${sessionPrefix(session)}/invoices/${invoice.id}`;
export const newInvoicePath = (session: LightSessionInterface) => `${sessionPrefix(session)}/invoices/new`;
export const editInvoicePath = (session: LightSessionInterface, invoice: InvoiceInterface) =>
  `${sessionPrefix(session)}/invoices/${invoice.id}/edit`;
